<template>
  <div>
    <div class="row justify-content-center player-bio__header mb-3" v-if="!player.linked_list">
      <div class="col-12 col-md-5">
        <img :src="getPlayerImage(player.id)" alt="Profile image" class="player-card-big">
      </div>
      <div class="col-12 col-md-7 align-self-center">
        <h3 class="mb-1">{{ translateIsoCountry(player.country_iso_3) }}</h3>
        <h4 class="mb-1">{{ player.title }}</h4>
        <h2 class="mb-1">{{ player.short_name }}</h2>
        <h3 v-if="player.sub_title" class="mb-1">{{ player.sub_title }}</h3>
        <CustomSharingOptions :title="`${$t('social.player')} ${translateIsoCountry(player.country_iso_3)} ${player.title} ${player.short_name}`" />
      </div>
    </div>
    <div class="row justify-content-center player-bio__header mb-3" v-if="player.linked_list && player.linked_list.length > 1">

      <div class="col-12 align-self-center">
        <div class="row justify-content-center relatives_container_float mb-3">
          <div class="col-3 d-none d-md-block">
            <img :src="getPlayerImage(player.id)" alt="Profile image" class="player-card-big">
          </div>
          <div class="col-12 col-md-6">
            <h3 class="mb-1">{{ translateIsoCountry(player.country_iso_3) }}</h3>
            <h4 class="mb-2">{{ player.title }}</h4>
            <h2 class="mb-1">{{ player.short_name }}</h2>
            <h3 v-if="player.sub_title" class="mb-1">{{ player.sub_title }}</h3>
          </div>
        </div>
        <div class="row relatives_container_float mb-3">
          <div class="col-4 col-md-4 p-1" v-for="r in player.linked_list" :key="r.id">
            <img :src="getPlayerImage(r.id)" width="100%" class="relative-image" />               
            <h3 class="title">{{ r.name }}</h3>
          </div>          
        </div>
      </div>
    </div>
    <div class="row justify-content-center player-bio__header mb-3" v-if="player.linked_list && player.linked_list.length == 1">
      <div class="col-5">
        <div class="multi-player">
          <img :src="getPlayerImage(player.id)" alt="Profile image" class="card-img-profile">
          <img :src="getPlayerImage(r.id)" width="100%" class="relative-image" v-for="r in player.linked_list" :key="r.id"/>
        </div>        
      </div>
      <div class="col-7 align-self-center">
        <h3 class="mb-1">{{ translateIsoCountry(player.country_iso_3) }}</h3>
        <h4 class="mb-2">{{ player.title }}</h4>
        <h2 class="mb-1">{{ player.short_name }}</h2>
        <h3 v-if="player.sub_title" class="mb-1">{{ player.sub_title }}</h3>
      </div>
    </div>
  </div>
</template>

<script>

  import CustomSharingOptions from '@/components/CustomSharingOptions.vue'
  import utils from '@/mixins/utils'

  export default {
    name: "PlayerMultiHeader",
    mixins: [utils],
    props: {
      player: Object
    },
    components: {
      CustomSharingOptions
    }
  }

</script>

<style lang="scss">

  .player-bio__header {
    h2 {
      color: #000;
      font-size: 41px;
      font-weight: 600;

      @media (max-width: 767.98px) {
        font-size: 31px;
      }
    }

    h3 {
      color: var(--app-color-red);
      font-size: 21px;
    }

    h4 {
      font-size: 27px;


      @media (max-width: 767.98px) {
        font-size: 21px;
      }
    }

    h5 {
      font-size: 16px;
      font-weight: 400;
    }

    .sharing-options__link {
      background: var(--app-color-light) !important;

      svg {
        color: var(--app-color-black) !important;
      }      
    }

    .region {
      color: var(--app-color-red);
    }

    .section_header {
      h5 {
        font-size: 14px;
        font-weight: 400;
        color: var(--app-color-red);
      }
    }

    .player-card-big {
      width: 100%;
      max-width: 270px;
      border-radius: 100%;
      background-color: var(--app-color-coin);
    }
    
    .multi-player {
      position: relative;
      width: 100%;
      padding-right: 25%;
      padding-bottom: 15%;

      .card-img-profile {
        width: 100%;
        border-radius: 100%;
        background: var(--app-color-coin);
      }

      .relative-image {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 45%;
        border-radius: 100%;
        background: var(--app-color-light);
      }
    }

    .player_bio {
      width: 100%;
      z-index: 0;

      &__content {
        max-width: 640px;
        margin: 0 auto;
        text-align: left;
        font-size: 18px;
      }

      img {
        background: var(--app-color-light);
      }
    }

    .relatives_container_float {
      .title {
        margin: 5px 0;
        color: var(--app-color-black);
        text-align: center;
      }

      .section_title {
        position: absolute;
        top: 0;
        right: 0;
      }

      .relative-image {
        border-radius: 100%;
        background: var(--app-color-light);
      }
    }
  }

</style>